export const UTM_TYPES = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

export const UTM_DYNAMIC_PARAMETERS_MAP = {
  utm_source: "utmSource=",
  utm_medium: "utmMedium=",
  utm_campaign: "utmCampaign=",
  utm_term: "utmTerm=",
  utm_content: "utmContent=",
} as const;
